import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * App-shaped skeleton shown while the main Index page loads.
 * Matches the real layout: sidebar + header + content grid.
 */
export const ViewLoadingFallback: React.FC = () => {
  return (
    <div className="min-h-screen flex bg-background">
      {/* Sidebar skeleton */}
      <div className="hidden md:flex flex-col w-56 border-r border-sidebar-border bg-sidebar p-4 space-y-6">
        <Skeleton className="h-7 w-28 bg-sidebar-accent" />
        <div className="space-y-2">
          {Array.from({ length: 7 }).map((_, i) => (
            <div key={i} className="flex items-center gap-3 px-2 py-1.5">
              <Skeleton className="h-4 w-4 rounded bg-sidebar-accent" />
              <Skeleton className="h-3.5 bg-sidebar-accent" style={{ width: `${60 + (i % 3) * 15}%` }} />
            </div>
          ))}
        </div>
      </div>
      {/* Main content area */}
      <div className="flex-1 flex flex-col">
        {/* Header skeleton */}
        <div className="h-14 border-b border-border flex items-center px-6 gap-4">
          <Skeleton className="h-5 w-32" />
          <div className="flex-1" />
          <Skeleton className="h-8 w-8 rounded-full" />
          <Skeleton className="h-8 w-8 rounded-full" />
        </div>
        {/* Content skeleton — 2-column card grid */}
        <div className="flex-1 p-6 space-y-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="rounded-lg border border-border p-6 space-y-3">
                <Skeleton className="h-5 w-40" />
                <Skeleton className="h-6 w-full rounded-full" />
                <div className="grid grid-cols-3 gap-3">
                  <Skeleton className="h-10 w-full" />
                  <Skeleton className="h-10 w-full" />
                  <Skeleton className="h-10 w-full" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
